import React from 'react';
import css from '../Table.module.scss';

export const NPSData = [
	{
		id: 1,
		rowOne: 'Tier I',
		rowTwo: [
			<span className={css.textGreen}>Salaried Individual</span>,
			'Investment up to 10% of Salary (Basic + Dearness Allowance) is deductible from taxable income u/s 80CCD (1) of Income Tax Act, 1961 subject to 1.5 lakhs limit of section 80C Additionally, investment up to Rs.50,000 is deductible from taxable income u/s 80CCD (1B) of Income Tax Act, 1961',
			<>
				<br />
				<br />
			</>,
			<span className={css.textGreen}>Self Employed Professionals</span>,
			'Investment up to 10% of Salary (Basic + Dearness Allowance) is deductible from taxable income u/s 80CCD (1) of Income Tax Act, 1961 subject to 1.5 lakhs limit of section 80C Additionally, investment up to Rs.50,000 is deductible from taxable income u/s 80CCD (1B) of Income Tax Act, 1961',
		],
		rowThree: [
			'Up to 40% of Corpus withdrawn in lump sum is exempt from tax Balance amount invested in Annuity is also fully exempt from tax.',
			<br />,
			'Pension received out of investment in Annuity is treated as income and will be taxed appropriately',
		],
	},
	{
		id: 2,
		rowOne: 'Tier II',
		rowTwo: 'There is no tax benefit on investment towards Tier II NPS Account',
		rowThree: 'Indexation benefit can be',
	},
];
